import { SKTProgressBar } from "../components/SKTProgressBar";
import { getFromQueryString } from "../utils/queryString";

import { SKTToggle } from "../components/SKTToggle";
import { Fragment } from "react";
import { SKTAction } from "../components/SKTAction";
import { LocalizedDate, LocalizedDateTime } from "../components/LocalizedDate";
import { SKTTable, SKTTableBody, SKTTableRow } from "../components/SKTTable";
import { Address } from "./common/Address";
import { apiGET } from "../hooks/APIHook";
import { SKTButton } from "../components/SKTButton";
import { popout } from "../utils/popout";
import { API_ENDPOINTS, BASE_URL } from "../config";
import { useAPI } from "../hooks/APIHook";
import { SKTBaseComponent } from "../components/SKTBaseComponent";
import {
  SKTPanel,
  SKTPanelHeading,
  SKTPanelBody,
} from "../components/SKTPanel";
import { useAuth } from "../hooks/Auth";
import GA4React, { useGA4React } from "ga-4-react";
import axios from "axios";
import { useEffect } from "react";

//const ga4react = new GA4React("G-G5VJL3LPX9");

const OrderAnalytics = ({ secret }) => {
  const [tracking] = useAPI(API_ENDPOINTS.order.getTrack(secret));

  if (tracking.status === "ok") {
    if (tracking.track) {
      /*
      ga4react.initialize().then((ga4) => {
        var d = {
          currency: "EUR",
          transaction_id: tracking.transaction.id,
          value: parseFloat(tracking.transaction.revenue),
          tax: parseFloat(tracking.transaction.tax),
          items: [
            {
              item_id: tracking.item.sku,
              item_name: tracking.item.name,
              price: parseFloat(tracking.item.revenue),
              item_category: tracking.item.category,
              quantity: 1,
            },
          ],
        };
        ga4.gtag("event", "purchase", d);
        //console.log("purchase done");
        const setTrackingUrl = BASE_URL + API_ENDPOINTS.order.setTrack(secret);
        axios.get(setTrackingUrl);
        const sendTracking =
          BASE_URL + API_ENDPOINTS.order.sendTracking(secret);
        axios.post(sendTracking, { data: d });
      });
      */
      var d = {
        currency: "EUR",
        transaction_id: tracking.transaction.id,
        value: parseFloat(tracking.transaction.revenue),
        tax: parseFloat(tracking.transaction.tax),
        items: [
          {
            item_id: tracking.item.sku,
            item_name: tracking.item.name,
            price: parseFloat(tracking.item.revenue),
            item_category: tracking.item.category,
            quantity: 1,
          },
        ],
      };
      // eslint-disable-next-line no-undef
      gtag("event", "purchase", d);
      //console.log("purchase done");
      const setTrackingUrl = BASE_URL + API_ENDPOINTS.order.setTrack(secret);
      axios.get(setTrackingUrl);
      const sendTracking = BASE_URL + API_ENDPOINTS.order.sendTracking(secret);
      axios.post(sendTracking, { data: d });
    }
  }
  return <Fragment />;
};

const ShipmentDimensions = ({ contents }) => {
  return (
    <SKTTableRow label="Mitat">
      {contents.depth} cm &times; {contents.width} cm &times; {contents.height}{" "}
      cm
    </SKTTableRow>
  );
};

const CarShipmentContents = ({ contents }) => {
  return (
    <Fragment>
      <SKTTableRow label="Merkki ja malli">
        {contents.make} {contents.model}
      </SKTTableRow>
      <SKTTableRow label="Rekisteri- tai runkonumero">
        {contents.regid}
      </SKTTableRow>
    </Fragment>
  );
};

const MachShipmentContents = ({ contents }) => {
  return (
    <Fragment>
      <SKTTableRow label="Merkki ja malli">
        {contents.make} {contents.model}
      </SKTTableRow>
      <SKTTableRow label="Paino">{contents.weight} kg</SKTTableRow>
      <ShipmentDimensions contents={contents} />
    </Fragment>
  );
};

const PalletShipmentContents = ({ contents }) => {
  return (
    <Fragment>
      <SKTTableRow label="Sisältö">{contents.contents}</SKTTableRow>
      <SKTTableRow label="EURO-lavoja">{contents.eur} kpl</SKTTableRow>
      <SKTTableRow label="FIN-lavoja">{contents.fin} kpl</SKTTableRow>
      <SKTTableRow label="TEHO-lavoja">{contents.teho} kpl</SKTTableRow>
      <SKTTableRow label="Kokonaispaino">{contents.weight} kg</SKTTableRow>
    </Fragment>
  );
};

const ParcelRow = ({ parcel }) => {
  if (parcel.type === "PARCEL")
    return (
      <SKTTableRow label="">
        {parcel.depth} cm &times; {parcel.width} cm &times; {parcel.height} cm,{" "}
        {parcel.weight} kg
      </SKTTableRow>
    );
  const palletDisplayName = {
    EURPALLET: "Eurolava",
    FINPALLET: "FIN-lava",
    HALFPALLET: "Teholava",
  };
  return (
    <SKTTableRow label="">
      {palletDisplayName[parcel.type] ?? "Lava"} {parcel.depth} cm &times;{" "}
      {parcel.width} cm, {parcel.weight} kg
    </SKTTableRow>
  );
};

const ParcelShipmentContents = ({ contents }) => {
  if (contents.details) {
    return (
      <Fragment>
        <SKTTableRow label="Sisältö">{contents.contents}</SKTTableRow>
        {contents.details.map((parcel) => (
          <ParcelRow parcel={parcel} />
        ))}
      </Fragment>
    );
  }
  return (
    <Fragment>
      <SKTTableRow label="Sisältö">{contents.contents}</SKTTableRow>
      <SKTTableRow label="Paino">{contents.weight} kg</SKTTableRow>
      <ShipmentDimensions contents={contents} />
    </Fragment>
  );
};

const ShipmentContents = ({ contents }) => {
  if (contents.type === "car")
    return <CarShipmentContents contents={contents} />;
  if (contents.type === "mach")
    return <MachShipmentContents contents={contents} />;
  if (contents.type === "pallet")
    return <PalletShipmentContents contents={contents} />;
  if (contents.type === "parcel")
    return <ParcelShipmentContents contents={contents} />;
  return <div />;
};

const OrderError = () => {
  return (
    <SKTPanel>
      <SKTPanelHeading>
        <h2>Tilausta ei löytynyt!</h2>
      </SKTPanelHeading>
      <SKTPanelBody>
        <p>
          Tarkista linkki ja yritä uudestaan. Jos tilaus on tehty kirjautuneena,
          voit myös etsiä tilauksen <a href="/kirjautuminen/">oman tilin</a>{" "}
          kautta.
        </p>
        <p>
          Ongelmatilanteissa ole hyvä ja{" "}
          <a href="/yhteystiedot/">ota yhteyttä asiakaspalveluumme</a>.
        </p>
      </SKTPanelBody>
    </SKTPanel>
  );
};

export const OrderStatus = ({ secret, moveToSecondPhase }) => {
  const { auth } = useAuth();
  const orderSecret = secret ?? getFromQueryString("o");
  const [orderStatus, refreshOrder] = useAPI(
    API_ENDPOINTS.order.status(orderSecret)
  );

  useEffect(() => {
    // eslint-disable-next-line no-undef
    gtag("event", "order_status");
  });

  if (orderStatus.status === "pending")
    return (
      <SKTPanel>
        <SKTPanelBody>
          <SKTProgressBar label="Tilauksen tietoja haetaan" />
        </SKTPanelBody>
      </SKTPanel>
    );

  if (orderStatus.status === "error") return <OrderError />;

  const order = orderStatus.order;

  const triggerPayment = () => {
    const url = API_ENDPOINTS.order.paymentRedirect(order.secret);
    apiGET(url).then((result) => {
      console.log(result.data);
      refreshOrder();
      const status = result.data.status;
      if (status === "redirect") window.location.href = result.data.href;
    });
  };

  const confirmBilling = () => {
    const url = API_ENDPOINTS.order.confirmBilling(order.secret);
    apiGET(url).then((result) => {
      console.log(result.data);
      refreshOrder();
    });
  };

  const cancelOrder = () => {
    const url = API_ENDPOINTS.order.cancel(order.secret);

    apiGET(url).then((result) => {
      refreshOrder();
      if (result.status === "error") {
        alert(`TODO: Tilauksen peruutus ei onnistunut, syy ${result.reason}`);
      }
    });
  };

  const trackShipment = () => {
    popout(API_ENDPOINTS.order.trackShipment(order.secret));
  };

  const showWaybill = () => {
    popout(API_ENDPOINTS.order.waybill(order.secret));
  };

  const showLabel = () => {
    popout(API_ENDPOINTS.order.label(order.secret));
  };

  const showInvoice = () => {
    popout(API_ENDPOINTS.order.invoice(order.secret));
  };

  const doOrder = () => {
    if (auth.is_corporate) {
      window.location.href = "/tavarakuljetukset-yritykset";
    } else {
      window.location.href = "/tavarakuljetukset/";
    }
  };

  return (
    <SKTPanel>
      <SKTPanelHeading>
        <h2>Yhteenveto tilauksesta #{order.number}</h2>
      </SKTPanelHeading>
      <SKTPanelBody>
        <SKTToggle when={order.status === "cancelled"}>
          <p>Kuljetustilauksesi on peruttu.</p>
          <SKTToggle when={order.payment === "paid"}>
            <p>
              Jos olet maksanut kuljetuksen verkkopankissa, ota yhteyttä
              asiakaspalveluun maksun palautuksesta.
            </p>
          </SKTToggle>
        </SKTToggle>

        <SKTToggle when={order.status === "processed"}>
          <p>Tilaus on välitetty eteenpäin kuljetusliikkeelle.</p>
        </SKTToggle>

        <SKTToggle when={order.status === "not_confirmed"}>
          <p>Tilaus odottaa vahvistamista.</p>
          <p>
            Tarkista tilauksen tiedot ja vahvista tilaus. Tämän jälkeen
            kuljetustilaus välitetään eteenpäin.
          </p>
          <SKTToggle when={moveToSecondPhase}>
            <SKTBaseComponent>
              <SKTButton
                label="Palaa muokkaamaan tilausta"
                onClick={moveToSecondPhase}
              />
            </SKTBaseComponent>
          </SKTToggle>
          <SKTToggle when={!moveToSecondPhase}>
            <SKTBaseComponent>
              <SKTButton label="Peruuta tilaus" onClick={cancelOrder} />
            </SKTBaseComponent>
          </SKTToggle>
        </SKTToggle>

        <SKTToggle when={order.status === "pending"}>
          <p>Tilaus odottaa välitystä kuljetusliikkeelle.</p>
          <p>
            Jos huomaat tilauksessa virheitä, voit vielä peruuttaa sen 15
            minuutin kuluessa tilauksen tekemisestä. Peruttu tilaus poistuu
            kokonaan ja on tehtävä alusta kokonaan uudestaan.
          </p>
          <SKTBaseComponent>
            <SKTButton label="Peruuta tilaus" onClick={cancelOrder} />
          </SKTBaseComponent>
          <p>
            Tämän jälkeen rahtikirjat siirtyvät tulostukseen ja sinulle
            läheteään linkki antamaasi sähköpostiosoitteeseen.
          </p>
        </SKTToggle>

        <p>
          Säilytä tilausnumero huolellisesti mahdollisia muutoksia tai
          lisäselvityksiä varten!
        </p>

        <SKTToggle when={order.waybills.waybill || order.waybills.label}>
          <p>Muista tulostaa rahtikirjat kuljetusliikettä varten!</p>
        </SKTToggle>

        <SKTTable>
          <SKTTableBody>
            <SKTToggle when={order.has_tracking}>
              <SKTTableRow label="Kuljetuksen seuranta">
                <SKTButton onClick={trackShipment} label="Avaa" />
              </SKTTableRow>
            </SKTToggle>
            <SKTToggle when={order.waybills.waybill}>
              <SKTTableRow label="Rahtikirja">
                <SKTButton onClick={showWaybill} label="Avaa" />
              </SKTTableRow>
            </SKTToggle>
            <SKTToggle when={order.waybills.label}>
              <SKTTableRow label="Kollilaput">
                <SKTButton onClick={showLabel} label="Kollilaput" />
              </SKTTableRow>
            </SKTToggle>

            <SKTToggle when={order.customer}>
              <SKTTableRow label="Tilaaja">
                <Address address={order.customer} />
              </SKTTableRow>
            </SKTToggle>
            <SKTTableRow label="Lähtöpaikka">
              <Address address={order.src} />
            </SKTTableRow>
            <SKTTableRow label="Määräpaikka">
              <Address address={order.dst} />
            </SKTTableRow>
            <ShipmentContents contents={order.contents} />
            <SKTTableRow label="Tilaus luotu">
              <LocalizedDateTime datetime={order.created} />
            </SKTTableRow>
            <SKTToggle when={order.booking_date}>
              <SKTTableRow label="Toivottu noutopäivä">
                <LocalizedDate date={order.booking_date} />
              </SKTTableRow>
            </SKTToggle>
            <SKTToggle when={order.pickup}>
              <SKTTableRow label="Arvioitu noutoaika">
                <LocalizedDateTime datetime={order.pickup} />
              </SKTTableRow>
            </SKTToggle>
            <SKTToggle when={order.delivery}>
              <SKTTableRow label="Arvioitu toimitusaika">
                <LocalizedDateTime datetime={order.delivery} />
              </SKTTableRow>
            </SKTToggle>
          </SKTTableBody>
        </SKTTable>

        <SKTToggle when={!(order.status === "cancelled")}>
          <SKTToggle when={order.payment === "paid"}>
            <p>Kuljetustilauksesi on maksettu</p>
            <SKTBaseComponent>
              <SKTButton label="Tee uusi tilaus" onClick={doOrder} />
            </SKTBaseComponent>
          </SKTToggle>

          <SKTToggle when={order.payment === "invoice_pending"}>
            <p>Kuljetustilauksesi on siirretty laskutukseen.</p>
            <SKTBaseComponent>
              <SKTButton label="Tee uusi tilaus" onClick={doOrder} />
            </SKTBaseComponent>
          </SKTToggle>

          <SKTToggle when={order.payment === "invoiced"}>
            <p>Kuljetustilauksesi on laskutettu.</p>
            <SKTBaseComponent>
              <SKTButton label="Tee uusi tilaus" onClick={doOrder} />
            </SKTBaseComponent>
          </SKTToggle>

          <SKTToggle when={order.payment === "not_paid"}>
            <p>Kuljetustilauksesi odottaa maksua.</p>
          </SKTToggle>

          <SKTToggle when={order.payment === "delayed"}>
            <p>
              Kuljetustilauksesi odottaa maksua. Tilaus välitetään eteenpäin,
              kun maksusuoritus saapuu meille.
            </p>
          </SKTToggle>
        </SKTToggle>
        <SKTToggle when={order.status === "not_confirmed"}>
          <SKTAction
            actionLabel="Siirry verkkopankkiin"
            onClick={triggerPayment}
            active={true}
          >
            Siirry verkkopankkiin maksamaan kuljetustilauksesi. Voit maksaa
            suomalaisilla verkkopankeilla ja yleisimmillä luottokorteilla.
          </SKTAction>
        </SKTToggle>
        <SKTToggle when={order.status === "not_confirmed_billing"}>
          <SKTAction
            actionLabel="Hyväksy tilaus"
            onClick={confirmBilling}
            active={true}
          >
            Vahvista kuljetustilaus. Tämän jälkeen tilaus siirretään
            käsittelyyn, ja se laskutetaan sinulta seuraavan koontilaskun
            yhteydessä.
          </SKTAction>
        </SKTToggle>
        <SKTToggle
          when={order.status === "pending" || order.status === "processed"}
        >
          <OrderAnalytics secret={order.secret} />
        </SKTToggle>
      </SKTPanelBody>
    </SKTPanel>
  );
};
